module.exports = __webpack_public_path__ + "f57e6ac0df8ec95b5f270f129cb0fc89.png";